import { BriefCreatorTypeEnum } from "@nlc/shared-types";

import { useCreateGraphicRequestFormContext } from "../useCreateGraphicRequestForm";
import { DetailedForm } from "./DetailedForm";
import useAIStream from "./hooks/useAIStream";
import { MagicalBriefCreator } from "./MagicalBriefCreator";
import { SingleInputForm } from "./SingleInputForm";
import { TabsHeader } from "./TabsHeader";

export function BriefCreatorSection() {
  const { watch } = useCreateGraphicRequestFormContext();
  const formType = watch("briefCreatorType");

  const aiStreamUtils = useAIStream();

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-3xl gap-y-lg">
      <TabsHeader isDisabled={Boolean(aiStreamUtils.streamedResponse)} />
      {formType === BriefCreatorTypeEnum.DETAILED && (
        <>
          <MagicalBriefCreator {...aiStreamUtils} />
          <DetailedForm isDisabled={Boolean(aiStreamUtils.streamedResponse)} />
        </>
      )}
      {formType === BriefCreatorTypeEnum.SINGLE && <SingleInputForm />}
    </div>
  );
}
